import styled from "styled-components";

export const MapCaptionStyled = styled.div`
  position: absolute;
  z-index: 2;
  right: 36px;
  bottom: 18px;
  width: 270px;

  & > div:first-child {
    margin-bottom: 18px;
    /* transition: "4.5s"; */
    /* max-height: 85vh; */
    /* height: 85vh; */
  }

  .map-caption__white {
    padding: 5px 12px;
    border-radius: 12px;
    box-shadow: 0 2px 6px 0 rgba(42, 46, 67, 0.1);
    background-color: #ffffff;
    min-height: 30px;
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: space-between;

    cursor: pointer;
  }

  .map-caption__sub-btn {
    height: 36px;
    padding: 5px 6px;
    border-radius: 12px;
    box-shadow: 0 3px 10px 0 rgba(72, 207, 173, 0.4);
    background-color: ${(props) =>
      props.selectMapLevel === 0 ? "#3278d7" : "#48cfad"};
    flex-grow: 1;
    margin-right: 12px;
    cursor: pointer;
  }

  .map-caption__myAdrs-btn {
    width: 36px;
    height: 36px;
    padding: 6px;
    border-radius: 12px;
    box-shadow: 0 3px 10px 0 rgba(42, 46, 67, 0.4);
    background-color: #2a2e43;
  }
`;
